import originAxios from 'axios'
// import store from '@/store/index.js'
import router from '@/router/index'
import { message } from "@/utils/message.js";
export default function axios(option) {
    return new Promise((resolve, reject) => {
        const instance = originAxios.create({
            baseURL: 'https://www.c4csgo.top/api/',
            // baseURL: 'http://192.168.1.11:8084',
            // baseURL: 'http://115.190.139.33:8084',
            timeout: 100000
        });
        instance.interceptors.request.use(config => {
            //token
            config.headers.webtoken = sessionStorage.getItem('token') || ''
            return config
        }, err => {
            return err
        })
        // 接口错误拦截
        instance.interceptors.response.use(res => {
            if (res.data.code === 200) {
                return res.data
            } else if (res.data.code === 10001 || res.data.code === 401) {
                //掉线/未登录
                router.push('/').then(res => {})
                message(false, '登录异常，请重新登录')
                sessionStorage.removeItem('token')
            } else if (res.data.code === 500 || res.data.code === 501) {
                message(false, res.data.message)
                return Promise.reject(res)
            } else {
                //报错
                // 提示消息
                // 抛出异常
                message(false, res.data.message)
                return Promise.reject(res)
            }
        })
        //传入对象进行网络请求
        instance(option).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}

